// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./variables.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.scss */
.customer {
  /* home-intro start*/
  /* home-intro end */
}
.customer .home-intro .card-icon {
  font-size: 32px;
  line-height: 0;
  width: 54px;
  height: 54px;
  flex-shrink: 0;
  flex-grow: 0;
  margin-right: 14px;
}
.customer .home-intro .headers {
  border-radius: 4px;
  padding: 10px;
  background: linear-gradient(to right, rgb(159, 212, 211) 0%, rgba(255, 255, 255, 0) 100%);
}
.customer .home-intro .headers p {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
}
.customer .home-intro .headers span {
  font-size: 24px;
  font-weight: bold;
}
.customer .home-intro .title {
  color: #000;
  font-size: 20px;
  font-weight: 500;
}
.customer .home-intro .date {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.customer .home-intro .date p {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  margin-right: 5px;
}
.customer .home-intro .homeintroposter {
  padding: 10px;
  background: linear-gradient(to right, rgb(159, 212, 211) 0%, rgba(255, 255, 255, 0) 100%);
  border-radius: 4px;
}
.customer .home-intro .homeintroposter .postertext p {
  color: var(--app-text-color);
  font-size: 40px;
  margin-bottom: 10px;
}
.customer .home-intro .homeintroposter .postertext .smarthub {
  font-size: 40px;
  background-color: #2d324d;
  font-weight: bolder;
  border-radius: 56px;
  margin-bottom: 10px;
  padding: 5px 41px;
  margin: 0px;
}
.customer .home-intro .homeintroposter .postertext .smarthub p:nth-child(1) {
  margin: 0;
  color: #fff;
}
.customer .home-intro .homeintroposter .postertext .smarthub p:nth-child(2) {
  margin: 0;
  color: #fff;
  font-size: 24px;
}
.customer .home-intro .homeintroposter .postertext span {
  color: #fff;
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/customer.scss"],"names":[],"mappings":"AAEA,gBAAA;AAIA;EAEE,oBAAA;EAuGA,mBAAA;AA1GF;AAKI;EACE,eAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAHN;AAMI;EACE,kBAAA;EACA,aAAA;EACA,yFAAA;AAJN;AAMM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAJR;AAOM;EACE,eAAA;EACA,iBAAA;AALR;AASI;EAEE,WAAA;EACA,eAAA;EACA,gBAAA;AARN;AAWI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AATN;AAWM;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AATR;AAaI;EAEE,aAAA;EACA,yFAAA;EACA,kBAAA;AAZN;AAqBQ;EACE,4BAAA;EACA,eAAA;EACA,mBAAA;AAnBV;AAsBQ;EAYE,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;AA/BV;AAcU;EACE,SAAA;EACA,WAAA;AAZZ;AAeU;EACE,SAAA;EACA,WAAA;EACA,eAAA;AAbZ;AAyBQ;EACE,WAAA;EACA,eAAA;AAvBV","sourcesContent":["// Common App CSS\n\n/* styles.scss */\n@import './variables.css';\n\n\n.customer {\n\n  /* home-intro start*/\n  .home-intro {\n    .card-icon {\n      font-size: 32px;\n      line-height: 0;\n      width: 54px;\n      height: 54px;\n      flex-shrink: 0;\n      flex-grow: 0;\n      margin-right: 14px;\n    }\n    \n    .headers {\n      border-radius: 4px;\n      padding: 10px;\n      background: linear-gradient(to right, rgb(159 212 211) 0%, rgba(255, 255, 255, 0) 100%);\n\n      p {\n        margin: 0;\n        font-size: 18px;\n        font-weight: 500;\n      }\n\n      span {\n        font-size: 24px;\n        font-weight: bold;\n      }\n    }\n\n    .title {\n      // margin: 0;\n      color: #000;\n      font-size: 20px;\n      font-weight: 500;\n    }\n\n    .date {\n      display: flex;\n      justify-content: flex-end;\n      align-items: center;\n\n      p {\n        margin: 0;\n        font-size: 18px;\n        font-weight: 500;\n        margin-right: 5px;\n      }\n    }\n\n    .homeintroposter {\n      \n      padding: 10px;\n      background: linear-gradient(to right, rgb(159 212 211) 0%, rgba(255, 255, 255, 0) 100%);\n      border-radius: 4px;\n\n      .postertext {\n        // display: flex;\n        // flex-direction: column;\n        // align-items: center;\n        // text-align: center;\n        // justify-content: center;\n\n        p {\n          color: var(--app-text-color);\n          font-size: 40px;\n          margin-bottom: 10px;\n        }\n\n        .smarthub {\n          p:nth-child(1) {\n            margin: 0;\n            color: #fff;\n          }\n\n          p:nth-child(2) {\n            margin: 0;\n            color: #fff;\n            font-size: 24px;\n          }\n\n          font-size: 40px;\n          background-color: #2d324d;\n          font-weight: bolder;\n          border-radius: 56px;\n          margin-bottom: 10px;\n          padding: 5px 41px;\n          margin: 0px;\n        }\n\n        span {\n          color: #fff;\n          font-size: 20px;\n        }\n\n        // p:nth-child(){\n        //   color:var(--app-text-color);\n        //   font-size: 40px;\n        //   margin-bottom: 10px;\n        // }\n      }\n    }\n  }\n\n  /* home-intro end */\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
